import React, { useState, useEffect} from 'react';

const CheckBoxControl = ({ condition = false, name, handleInput, label, style={}, disabled=false }) => {
  const [caption, setCaption] = useState('');

  useEffect(() => {
    if (label===undefined){
      if (name.includes('.')) {
        const [parentKey, childKey] = name.split('.');
        setCaption( convertSnakeCaseToText(childKey));
      } else {
        setCaption( convertSnakeCaseToText(name));
      }
    } else {
      setCaption(label)
    }
  }, [name]);

  const convertSnakeCaseToText = (snakeCaseString) => {
    const words = snakeCaseString.split('_');
    const capitalizedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1));
    return capitalizedWords.join(' ');
  }

  return (
    <div className="form-check">
      <input
        style={style}
        name={name}
        checked={condition}
        className="form-check-input"
        onChange={(e) => handleInput(e)}
        type="checkbox"
        id={`switch_${name}`}
      />
      <label className="form-check-label" htmlFor={`switch_${name}`}>
        {caption}
      </label>
    </div>
  );
};

export default CheckBoxControl;
